import { Component, DestroyRef, signal } from '@angular/core'
import type { OnDestroy, OnInit } from '@angular/core'
import { AppPaths } from 'src/app/app-routing.module'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { DataDatasourceInfoService } from '../../services/data-datasource-info.service'

@Component({
  selector: 'app-datasource-dropdown',
  templateUrl: './datasource-dropdown.component.html',
  styleUrls: ['./datasource-dropdown.component.scss'],
  providers: [DataDatasourceInfoService],
  standalone: false,
})
export class DatasourceDropdownComponent implements OnInit, OnDestroy {
  public allowedDatasources: string[] = []
  public currentDatasource = signal<string>('')
  private datasourceInfo: Record<string, string> = {}

  constructor(
    public appState: AppStateService,
    private readonly dataDatasourceInfoService: DataDatasourceInfoService,
    private readonly destroyRef: DestroyRef,
  ) {
    this.currentDatasource.set(this.appState.selectDatasource() || '')
    this.evaluateQueryParameters()
    this.appState.stateChanged.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.evaluateQueryParameters()
    })
  }

  ngOnInit(): void {
    this.dataDatasourceInfoService
      .loadDatasourceInfo()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((datasourceInfo) => {
        this.datasourceInfo = datasourceInfo
        this.allowedDatasources = Object.values(datasourceInfo)

        const queryDatasourceKey = this.appState.selectDatasource()
        const selectedDatasource = queryDatasourceKey
          ? this.getDatasourceValue(queryDatasourceKey)
          : this.allowedDatasources[0] || ''
        this.currentDatasource.set(selectedDatasource)

        if (!queryDatasourceKey || !this.getDatasourceValue(queryDatasourceKey)) {
          this.updateQueryParameters()
        }
      })
  }

  ngOnDestroy(): void {}

  evaluateQueryParameters() {
    const newDatasourceKey = this.appState.selectDatasource()
    const newDatasource = newDatasourceKey ? this.getDatasourceValue(newDatasourceKey) : ''
    if (newDatasource) {
      this.currentDatasource.set(newDatasource)
    }
  }

  setCurrentDatasource(datasource: string) {
    this.currentDatasource.set(datasource)
    this.updateQueryParameters()
  }

  updateQueryParameters() {
    this.appState.setState(AppPaths.Customer, {
      datasource: this.getDatasourceKey(this.currentDatasource()) || undefined,
    })
  }

  private getDatasourceValue(datasourceKey: string): string {
    return this.datasourceInfo[datasourceKey] || ''
  }

  private getDatasourceKey(datasourceValue: string): string {
    return (
      Object.entries(this.datasourceInfo).find(([, value]) => value === datasourceValue)?.[0] || ''
    )
  }
}
